import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { TotalShow } from '../../component/common';
import axios from 'axios'
import {
  Logo,
  Search,
  OwenList,
  OtherList,
} from '../../component/search/index'
import { Loading } from '../../component/common'
import message, { Message } from '../../component/common/Message'

let timer = null
let onScrollFetch = true

function SearchRouter(props) {

  const {
    urlSearch,
    onBack,
  } = props
  /* eslint-disable */
  const history = new useHistory()
  let faSearch = window.location.search.split('search=')[1] ? decodeURIComponent(window.location.search.split('search=')[1]) : ''
  let search = history.location && history.location.state ? history.location.state.search : ''

  let [mode, setMode] = useState('all')
  let [isInfo, setIsInfo] = useState(false)
  let [searchStr, setSearchStr] = useState(urlSearch || faSearch || search)
  let [loading, setLoading] = useState(false)
  let [listData, setListData] = useState([])
  let [owens, setowens] = useState([])
  let [others, setothers] = useState([])
  let [page, setPage] = useState(1)
  let [hasMore, sethasMore] = useState(true)
  let [has_m2m, sethas_m2m] = useState(false)
  let [curlist_has_m2m, setCurM2m] = useState(false)
  let [beds, setBeds] = useState('123456')
  let [source, setsource] = useState('0123')
  let [curStr, setCurStr] = useState()

  const filterList = (list, bedsStr, sourceStr) => {
    let target = [],
    has_m2m = false;
    list.map(item => {
      if ( (!bedsStr || (bedsStr && bedsStr.includes(item.bedroom)) || (bedsStr && bedsStr.includes(6) && item.bedroom > 6) ) && (sourceStr && sourceStr.includes(item.source))) {
        target.push(item)
        if (item.source === 0) {
          has_m2m = true
        }
      }
    })
    setCurM2m(has_m2m)
    return target
  }

  const goHome = useCallback(() => {
    if (onBack) {
      return onBack()
    }
    if (urlSearch) {
      let rmQueryUrl = window.location.href.split('?')[0]
      window.location.href = rmQueryUrl
    } else {
      history.push('/websearch')
    }
  }, [history, urlSearch])

  const getRenderListDataByType = useCallback((list, isOther) => {
    if (!list) return []
    let ohterData = [],
    ownData = [];
    list.map(item => {
      if (item.ad) {
        ownData.push(item)
      } else {
        ohterData.push(item)
      }
    })
    return !!isOther ? ohterData : ownData
  }, [])

  const classifyTotalList = useCallback(list => {
    if (!list || !list.length) {
      setowens([])
      setothers([])
      setListData([])
    } else {
      let filters = filterList(list, beds.split('+')[0], source.split('+')[0])
      setowens(getRenderListDataByType(filters))
      setothers(getRenderListDataByType(filters, true))
      setListData(filters)
    }
  }, [beds, source, setowens, setothers, setListData, getRenderListDataByType])


  const resetStep = useCallback(() => {
    setMode('all')
    classifyTotalList([])
    setIsInfo(false)
  }, [setMode, setIsInfo, classifyTotalList])

  const setModeToInfo = useCallback(() => {
    setMode('owen')
    setIsInfo(true)
  }, [setMode, setIsInfo])

  const clearTimer = useCallback(() => {
    timer && window.clearTimeout(timer)
    timer = null
    setLoading(false)
    onScrollFetch = false
  }, [setLoading])

  const setTimer = useCallback((time = 3, source) => {
    timer && clearTimer()
    setLoading(true)
    timer = window.setTimeout(() => {
      source.cancel('Timeout, please try again')
      clearTimer()
    }, time * 1000)
  }, [clearTimer, setLoading])

  // getList
  const getList = useCallback(() => {
    if (timer) return
    let url = `/chrome_extension/v1/search?search_str=${searchStr}&page=${page}&per_page=100`
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    setTimer(20, source)
    axios({
      url,
      method: 'get',
      cancelToken: source.token
    })
      .then(originRes => {
        let res = originRes.data,
        has_m2m = res.has_m2m; // ad houses data have m2m ?
        if (res && res.data && res.data.length) {
          let nowData = res.data,
          has_more = res.has_more;
          classifyTotalList(page === 1 ? nowData : listData.concat(nowData))
          sethasMore(has_more)
        } else {
          sethasMore(false)
        }
        sethas_m2m(has_m2m)
        clearTimer()
      })
      .catch(err => {
        message(err.message || 'faild', 'warning')
        clearTimer()
      })
  }, [classifyTotalList, sethasMore, setTimer, clearTimer, sethas_m2m, listData, searchStr, page])

  const onSubmit = useCallback((search) => {
    resetStep()
    if (search === searchStr) {
      classifyTotalList([])
      if (page !== 1) {
        setPage(1)
      } else {
        getList()
      }

    } else {
      setSearchStr(search)
      setPage(1)
    }
  }, [page, resetStep, setSearchStr, setPage, classifyTotalList, searchStr, curStr])

  const onScroll = useCallback((e) => {
    if (loading || !hasMore || onScrollFetch || mode === 'owen') return
    let faDiv = e.target,
    sonDiv = document.getElementById('m2m_chrome_ex_scroll_div'),
    faH = faDiv.offsetHeight,
    faScroll = faDiv.scrollTop,
    sonH = sonDiv.offsetHeight,
    curDiff = sonH - (faScroll + faH);
    if (curDiff < 45) {
      let curPage = page + 1
      onScrollFetch = true
      setPage(curPage)
    }
  }, [loading, hasMore, page, mode, setPage])

  const onFilter = useCallback((beds, source) => {
    // use uniq, Trigger Update
    let uniq = new Date().valueOf();
    resetStep()
    classifyTotalList([])
    setSearchStr(curStr)
    setBeds(`${beds}+${uniq}`)
    setsource(`${source}+${uniq}`)
    setPage(1)
  }, [setBeds, setsource, setPage, getList, curStr])

  // useEffect listen search
  useEffect(() => {
    getList()
  }, [searchStr, page, beds, source])

  useEffect(() => {
    setCurStr(urlSearch || faSearch || search)
  }, [])

  const searchChange = useCallback(str => {
    setCurStr(str)
  }, [])

  return (
    <div
      className='flex flex-col h-[100vh]'
    >
        <Loading
          loading={loading}
        />
        <Message />
        <div className='h-[147px] overflow-hidden  px-3'>
          <Logo pClassName='mb-[12px]' onLogo={goHome}/>
          <Search
            onSubmit={onSubmit}
            initValue={searchStr}
            loading={loading}
            onChange={searchChange}
          />
        </div>

        <div className='px-3 mb-[12px]'>
          <TotalShow
            pClassName='mb-0'
            total={listData.length}
            lastTitle={ curlist_has_m2m || !listData.length ? ' houses for you' : ' houses on other platforms'}
            onSubmit={onFilter}
          />
        </div>

        <div
          className='flex-1 overflow-y-scroll overflow-y-overlay px-3'
          id='m2m_scroll_contain'
          onScroll={onScroll}
          style={{ overflowAnchor: 'none' }}
        >
          <div id='m2m_chrome_ex_scroll_div'>
            {/* owen list always show */}
            <OwenList
              pClassName='mt-0'
              setMode={setModeToInfo}
              isInfo={isInfo}
              data={owens}
              loading={loading}
              location={searchStr}
              has_m2m={has_m2m && curlist_has_m2m}
              isShowList={mode === 'all'}
              total={hasMore ? `${listData.length}+` : `${listData.length}`}
              isShowTotal={!!listData.length}
            />
            {/* other list show by owen list data */}
            <div className={`${mode === 'all' ? '' : ' hidden'}`}>
              <OtherList
                isShowTotal={false}
                data={others}
                location={searchStr}
                hasMore={hasMore}
              />
            </div>
          </div>
          {
            !loading && !hasMore && listData.length && mode === 'all' ? <div className=' text-2xl text-grey h-[120px] flex justify-center items-center'>no more result</div> : ''
          }
        </div>
    </div>
  );
}

export default SearchRouter;
